/*
 * @Description: 企业展示
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:08
 * @LastEditTime: 2019-07-24 14:08:40
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 动态新闻
export const exhibitionTab = (params, id) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/news/getInfo`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCmsNews',
        id: id
      }, params))
    }
  })
}
// 核心服务
export const detailsCore = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/msg/findMsg`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCoreProject'
      }, params))
    }
  })
}
//  关于我们
export const detailsAbout = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/msg/findMsg`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findAboutUs'
      }, params))
    }
  })
}

